import {
  Account,
  AccountGroupMembership,
} from '@libs/src/models/account.model';

import includes from 'lodash-es/includes';
import isEmpty from 'lodash-es/isEmpty';

export function checkCanStartConversation(
  user: Account,
  targetAccount: Account,
) {
  const userGroupIds = user.groups.map(
    (userGroup: AccountGroupMembership) => userGroup.document._id,
  );
  const targetInviteableGroups = targetAccount.groups
    .filter((membership: AccountGroupMembership) => membership.inviteable)
    .filter((membership: AccountGroupMembership) =>
      includes(userGroupIds, membership.document._id),
    );
  return !isEmpty(targetInviteableGroups);
}
